<template>
  <div class="kp-modular-nav-left">
    <div class="kp-modular-name">
      <input class="kp-modular-name-txt" :value="name" type="text" @change="boxSetName($event)" required>
      <label>{{ $t('general.labels.box_name') }}</label>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  computed: mapGetters({
    name: 'boxName',
  }),
  methods: mapActions([
    'boxSetName',
  ]),
};
</script>



/** WEBPACK FOOTER **
 ** Name.vue?02019ba3
 **/